import { UtilDocumentId } from '@formbird/shared';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OfflineUtilService {

  constructor() { }

  getNextId(url) {
    return UtilDocumentId.generateId();
  }
}
